import {Component, input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatRippleModule} from '@angular/material/core';

type Size = 'small' | 'big' | 'small-border' | 'big-border';
type ColorVariant = 'primary' | 'secondary' | 'grey' | 'transparent' | 'transparent-white' | 'transparent-error' | 'secondary-dark' | 'cancelled';

@Component({
  selector: 'app-icon-button',
  imports: [MatIconModule, MatRippleModule],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss'
})
export class IconButtonComponent {
  icon = input<string | undefined>(undefined);
  number = input<number | undefined>(undefined);

  /** Needed whenever the icon is all there is to say what the button does. */
  ariaLabel = input<string | undefined>(undefined);

  size = input<Size>('big');
  colorVariant = input<ColorVariant>('transparent');

  get cssClass() {
    return `icon-button icon-button-${this.size()} icon-button-${this.colorVariant()}`;
  }
}
